export const SnackbarType = Object.freeze({
    INFO: 'INFO',
    WARNING: 'WARNING',
    ERROR: 'ERROR',
    SUCCESS: 'SUCCESS',
    FILEDOWNLOAD: 'FILEDOWNLOAD'
});